<template>
  <el-card shadow="always" style="height: 100%" :body-style="{ padding: '0px' }">
    <div class="row bg-light-grey py-3 px-3">
      <div class="col-12 d-flex justify-content-between">
        <h3 class="mb-0 text-dark-blue">Pending Ottley Payments</h3>
        <i role="button" class="el-icon fa-lg mt-1 has-interaction text-white" @click="showData = !showData"
          :class="showData ? 'el-icon-arrow-right' : 'el-icon-arrow-down'"></i>
      </div>
    </div>
    <div class="row p-2" v-loading="loading" v-if="showData">
      <div class="col-12 p-0">
        <el-table :data="purchases.data" @cell-click="handleCellClick" :row-class-name="rowClass"
          class="d-none d-lg-block">
          <el-table-column label="Trade #" prop="id" width="100px">
            <template slot-scope="scope">
              <p class="pl-2 m-0">
                <a href="#" alt="Edit" @click="$event.preventDefault()">
                  {{ scope.row.ref_id }}
                </a>
              </p>
            </template>
          </el-table-column>
          <el-table-column label="Producer" prop="id">
            <template slot-scope="scope">
              {{ scope.row.business.short_name }}
            </template>
          </el-table-column>
          <el-table-column label="Head Purchased" prop="id">
            <template slot-scope="scope">
              {{
                scope.row.line_items.reduce(
                  (sum, l) => sum + Number(l.quantity || 0),
                  0
                )
              }}
            </template>
          </el-table-column>
          <el-table-column label="Value" prop="value">
            <template slot-scope="scope">
              ${{ $_toLocaleString(scope.row.dollar_value, 2) }}
            </template>
          </el-table-column>
          <el-table-column label="Purchased" prop="invoice_invoice_date">
            <template slot-scope="scope">
              {{
                scope.row.bill_invoice_date
                ? moment(scope.row.bill_invoice_date).format("DD/MM/YYYY")
                : "--"
              }}
            </template>
          </el-table-column>
          <el-table-column label="Due" prop="bill_due_date">
            <template slot-scope="scope">
              {{
                scope.row.bill_due_date
                ? moment(scope.row.bill_due_date).format("DD/MM/YYYY")
                : "--"
              }}
            </template>
          </el-table-column>
          <el-table-column width="100px" label="Status" prop="contract_expiry_at">
            <template slot-scope="scope">
              <div class="text-center rounded alert p-0 m-0 alert-status"
                :class="['alert-' + purchaseStatus(scope.row).tag_type]">
                {{ purchaseStatus(scope.row).new_name }}
              </div>
              <el-button v-if="[1, 2].includes(scope.row.purchase_status_id)"
                class="btn-secondary w-100 edit-button d-none">
                Edit
              </el-button>
            </template>
          </el-table-column>
        </el-table>
        <el-table :data="purchases.data" @cell-click="handleCellClick" :row-class-name="rowClass"
          class="d-block d-lg-none">
          <el-table-column label="Trade #" prop="id" width="100px">
            <template slot-scope="scope">
              <p class="pl-2 m-0">
                <a href="#" @click="$event.preventDefault()">
                  {{ scope.row.id }}
                </a>
              </p>
            </template>
          </el-table-column>
          <el-table-column label="Producer" prop="id">
            <template slot-scope="scope">
              {{ scope.row.business.short_name }}
            </template>
          </el-table-column>
          <el-table-column label="Value" prop="value">
            <template slot-scope="scope">
              ${{ $_toLocaleString(scope.row.dollar_value, 2) }}
            </template>
          </el-table-column>
          <el-table-column label="Due" prop="bill_due_date">
            <template slot-scope="scope">
              {{
                scope.row.bill_due_date
                ? moment(scope.row.bill_due_date).format("DD/MM/YYYY")
                : "--"
              }}
            </template>
          </el-table-column>
          <el-table-column width="100px" label="Status" prop="contract_expiry_at">
            <template slot-scope="scope">
              <div class="text-center rounded alert p-0 m-0 alert-status"
                :class="['alert-' + purchaseStatus(scope.row).tag_type]">
                {{ purchaseStatus(scope.row).new_name }}
              </div>
              <el-button v-if="[1, 2].includes(scope.row.purchase_status_id)"
                class="btn-secondary w-100 edit-button d-none">Edit</el-button>
            </template>
          </el-table-column>
        </el-table>
        <div class="py-3 d-flex justify-content-center justify-content-xl-end">
          <el-pagination small layout="prev, pager, next" :current-page.sync="currentPage"
            @current-change="handleCurrentChange" :background="false" :page-size="perPage"
            :page-count="purchases.last_page" :total="purchases.total" />
        </div>
      </div>
    </div>

    <business-purchase-form-modal :initial_business="selectedBusiness" :initial_purchase="selectedPurchase"
      v-if="purchaseFormModalShow" @close="onClosePurchaseForm" :show-form-only="true" />
    <business-purchase-changes-modal :initial_purchase="selectedPurchase" v-if="purchaseChangesModalShow"
      @close="onClosePurchaseChangesModal" />
  </el-card>
</template>
<script>
import Formatter from "../../../../mixins/OttleyFormatter";
import Purchase from "../../../modelsPortal/Purchase";
import PurchaseStatuses from "../../../../constants/PurchaseStatuses.js";
import OrderConfirmation from "../../../modelsPortal/OrderConfirmation";
export default {
  mixins: [Formatter],
  props: {},
  mounted() {
    this.getPurchases();
  },
  data() {
    return {
      showData: true,
      purchases: [],
      loading: false,
      page: 1,
      currentPage: 1,
      perPage: 10,
      printOrderLoading: false,
      selectedPurchase: null,
      selectedBusiness: null,
      purchaseFormModalShow: false,
      purchaseChangesModalShow: false,
    };
  },
  computed: {},
  methods: {
    rowClass({ row, rowIndex }) {
      let defaultClass = 'px-2';
      if (![1, 2].includes(row.purchase_status_id) && row.pending_client_transactions.length == 0) {
        defaultClass += ' has-interaction';
      } else if ([1, 2].includes(row.purchase_status_id) && row.pending_client_transactions.length == 0) {
        defaultClass += ' edit-row';
      }
      return defaultClass;
    },
    handleCellClick(row, column, cell, event) {
      if (row.pending_client_transactions.length == 0) {
        if ([1, 2].includes(row.purchase_status_id)) {
          this.showPurchaseModal(row);
        } else
          this.downloadDocument(row.invoice_collections);
      } else {
        this.selectedPurchase = row;
        this.purchaseChangesModalShow = true;
      }
    },
    purchaseStatus(purchase) {
      let statuses = Object.keys(PurchaseStatuses).map((key) => {
        return PurchaseStatuses[key];
      });

      let status_id = statuses.find((x) => x.id == purchase.purchase_status_id);

      if ([3, 6, 7].includes(purchase.purchase_status_id)) {
        status_id = { new_name: "Approved", tag_type: "success" };
      }

      return status_id;
    },
    getPurchases(page = 1) {
      this.loading = true;

      let purchases = Purchase.page(page)
        .select(
          "id",
          "ref_id",
          "business_id",
          "bill_invoice_date",
          "purchase_status_id",
          "value",
          "number_of_head",
          "bill_due_date",
          "livestock_class_id",
          "purchase_type_id",
          "average_weight",
          "property_id",
          "term",
          "reference_code",
          "bill_due_date",
          "agent_advised_term",
        )
        .where("client_portal_status", true)
        .include(
          "business.agency",
          "business.properties",
          "invoiceCollections",
          "media",
          "lineItems",
          "additionalCosts",
          "pendingClientTransactions.updateFields"
        )
        .params({ 'per_page': this.perPage })
        .orderBy("purchase_status_id", "id");

      purchases
        .get()
        .then((res) => {
          this.loading = false;
          this.purchases = res;
          this.currentPage = page;
        })
        .catch((errors) => {
          this.loading = false;
          this.$message({
            type: "error",
            message: "Looks like something went wrong.",
          });
        });
    },
    handleCurrentChange(page = 1) {
      this.getPurchases(page);
    },
    showPurchaseModal(purchase) {
      this.selectedPurchase = purchase;
      this.selectedBusiness = purchase.business;
      this.purchaseFormModalShow = true;
    },
    onClosePurchaseForm() {
      this.purchaseFormModalShow = false;
      this.getPurchases(1);
    },
    onClosePurchaseChangesModal() {
      this.purchaseChangesModalShow = false;
      this.getPurchases(1);
    },
    downloadDocument(media) {
      if (media[0]) {
        var anchor = document.createElement("a");
        anchor.href = media[0].url;
        anchor.target = "_blank";
        anchor.download = media[0].file_name;
        anchor.click();
      }
    },
    getOrderConfirmation(event, purchase) {
      event.preventDefault();
      this.loading = true;
      new OrderConfirmation({ purchase_id: purchase.id })
        .for(new Purchase(purchase))
        .save()
        .then((result) => {
          this.loading = false;
          if (result.media.length <= 0) {
            this.$message({
              type: "info",
              message: "There are not documents to download.",
            });
          } else {
            result.media.forEach((document) => {
              if (document.url) window.open(document.url, "_blank"); // open
            });
          }
        })
        .catch((err) => {
          this.loading = false;
        });
    },
  },
};
</script>
<style>
.edit-row:hover .alert-status {
  display: none;
}

.edit-row:hover .edit-button {
  display: inline-block !important;
}
</style>